import React from "react"

const IconLoading = props => (
  <svg width="60" height="59" viewBox="0 0 60 59" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M37.2964 48.6273C44.7337 45.7118 50 38.4709 50 30C50 18.9543 41.0457 10 30 10C18.9543 10 10 18.9543 10 30C10 38.8023 15.6864 46.2764 23.586 48.9494L20.1569 58.3479C8.42307 54.2741 0 43.1207 0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 42.7894 51.997 53.7096 40.7256 58.0258L37.2964 48.6273Z" fill="#FCFBF9" />
  </svg>
)

export default IconLoading
